<template>
  <div v-loading="loading">
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form label-position="top"
               :model="dataForm"
               :rules="dataRule"
               ref="dataForm">
        <el-row class="row-mar-l">
          <!-- * 角色编码 -->
          <el-col :span="6">
            <el-form-item :label="$t('role.roleCode')"
                          prop="roleCode">
              <el-input v-model="dataForm.roleCode"
                        :placeholder="$t('organization.orgCodeMessage')"
                        :disabled="true">
              </el-input>
            </el-form-item>
          </el-col>
          <!-- * 角色名称 -->
          <el-col :span="6">
            <el-form-item :label="$t('role.roleName')"
                          prop="roleName">
              <el-input v-model="dataForm.roleName"
                        :placeholder="$t('role.roleName')">
              </el-input>
            </el-form-item>
          </el-col>
          <!-- * 角色分类 -->
          <el-col :span="6">
            <el-form-item :label="$t('role.authType')"
                          prop="roleType">
              <el-select v-model="dataForm.roleType"
                         filterable
                         clearable
                         :disabled="this.dataForm.roleId != null"
                         @change="changeRoleAuthType"
                         :placeholder="$t('role.authType')">
                <el-option v-for="(item,index) in roleType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- * 组织类型 -->
          <el-col :span="6"
                  v-if="!roleTypeActivity">
            <el-form-item :label="$t('organization.orgType')"
                          prop="orgType">
              <el-select v-model="dataForm.orgType"
                         :placeholder="$t('organization.orgType')"
                         clearable
                         @change="orgTypeChange">
                <el-option v-for="(item,index) in roleOrgType"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <el-col :span="6"
                  v-if="!roleTypeActivity">
            <!-- 权限分类 -->
            <el-form-item :label="$t('user.permissionclassification')"
                          prop="authType">
              <el-select v-model="dataForm.authType"
                         filterable
                         clearable
                         :placeholder="$t('user.select')"
                         @change="changeAuthType">
                <el-option v-for="(item,index) in authTypeArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- * 数据范围分类 -->
          <el-col :span="6">
            <el-form-item :label="$t('role.roleOrgScope')"
                          prop="roleOrgScope">
              <el-select v-model="dataForm.roleOrgScope"
                         filterable
                         clearable
                         @change="changeScope()"
                         :placeholder="$t('role.roleOrgScope')">
                <el-option v-for="(item,index) in roleOrgScopeOption"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- * 是否内置岗位 -->
          <el-col :span="6">
            <el-form-item :label="$t('role.defaultFlag')"
                          prop="defaultFlag">
              <el-select v-model="dataForm.defaultFlag"
                         :placeholder="$t('role.defaultFlag')"
                         :disabled="true">
                <el-option v-for="(item,index) in confirmStateArr"
                           :key="index"
                           :label="item.name"
                           :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l"
                v-if="showOrg">
          <el-col :span="18">
            <!-- 数据范围  -->
            <el-form-item class="company-distributor"
                          :label="$t('role.companyDistributor')"
                          prop="orgIdList">
              <el-select v-model="dataForm.orgIdList"
                         multiple
                         filterable
                         collapse-tags
                         remote
                         clearable
                         reserve-keyword
                         :placeholder="$t('user.input')"
                         :remote-method="querySearch">
                <el-option v-for="item in results"
                           :key="item.orgId"
                           :label="item.name"
                           :value="item.orgId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="row-mar-l">
          <el-col :span="12"
                  v-show="showMenu">
            <el-form-item size="mini"
                          :label="$t('role.menuList')">
              <el-tree :data="menuList"
                       :props="{ label: 'name', children: 'children' }"
                       node-key="menuId"
                       ref="menuListTree"
                       accordion
                       show-checkbox>
              </el-tree>
            </el-form-item>
          </el-col>
          <el-col :span="12"
                  v-show="showFlow">
            <el-radio-group v-model="radio">
              <el-form-item size="mini"
                            :label="$t('role.deptList')">
                <el-tree :data="activityList"
                         :props="{ label: 'activityName', children: 'children' }"
                         node-key="activityId"
                         :expand-on-click-node="false"
                         ref="activityListTree">
                  <span class="custom-tree-node"
                        slot-scope="{ node, data }">

                    <span>
                      <span v-show="data.activityType != '20'">{{ node.label }}</span>
                      <el-radio v-show="data.activityType == '20'"
                                :title='node.label'
                                :label='data.activityId'> {{ node.label }}</el-radio>
                    </span>
                  </span>
                </el-tree>
              </el-form-item>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-form>
      <div class="btn-position-up">
        <el-button type="primary" :disabled="saveBtnDisabled"
                   @click="dataFormSubmitHandle()">{{ $t('organization.save') }}</el-button>
        <el-button @click="backPage()">{{ $t('organization.back') }}</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import debounce from 'lodash/debounce'
import { treeDataTranslate } from '@/utils'
import VueI18n from '@/i18n'
// *************************角色范围属性
// 指定范围维护数据
const ROLE_ORG_SCOPE = '40'
// *************************角色分类属性
// 功能类
const ROLE_AUTH_MENU = '10'
// 流程类
const ROLE_AUTH_FLOW = '20'

const language = VueI18n.locale
let key = 'Cn'
// 判断中英文
if (language === 'zh-CN') {
  key = 'Cn'
} else {
  key = 'En'
}
export default {
  data() {
    let _this = this
    return {
      loading: true,
      saveBtnDisabled: false,
      visible: false,
      menuList: [],
      activityList: [],
      dataForm: {
        // 角色名称
        roleName: '',
        // 权限分类
        authType: '',
        // 角色分类
        roleType: '',
        // 数据范围分类
        roleOrgScope: '',
        // 菜单列表
        menuIdList: [],
        // 组织列表
        orgIdList: [],
        // 工作流列表
        activityIdList: [],
        defaultFlag: '20',
        orgType: '',
        roleCode: ''
      },
      emptyForm: {
        // 角色名称
        roleName: '',
        // 权限分类
        authType: '',
        // 角色分类
        roleType: '',
        // 数据范围分类
        roleOrgScope: '',
        // 菜单列表
        menuIdList: [],
        // 组织列表
        orgIdList: [],
        // 工作流列表
        activityIdList: [],
        defaultFlag: '20',
        orgType: '',
        roleCode: ''
      },
      // 数据范围分类填充
      roleOrgScopeOption: [],
      // 数据范围分类
      roleOrgScope: _this.enums['roleOrgScope'],
      // 流程数据范围分类
      procedureRoleScope: _this.enums['ProcedureRoleScope'],
      // 角色分类
      roleType: _this.enums['authType'],
      // 是否显示公司
      showOrg: false,
      // 公司list
      results: [],
      // 权限分类
      perClassification: _this.enums['perClassification'],
      perClassificationMerga: [],
      authTypeArr: [],
      // 是否
      confirmStateArr: this.enums['defaultFlag'],
      // 组织类型
      orgTypeArr: _this.enums['orgType'],
      roleOrgType: [],
      // 显示菜单
      showMenu: false,
      showFlow: false,
      roleTypeActivity: false,
      radio: ''
    }
  },
  computed: {
    dataRule() {
      return {
        roleName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 40, message: this.$t('validate.validateLength', { 'handle': '40' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharacters, trigger: 'blur' }
        ],
        orgType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        authType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        roleType: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        roleOrgScope: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        orgIdList: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_ROLE, (data) => {
      this.roleOrgScopeOption = this.roleOrgScope
      this.roleTypeActivity = false
      if (this.$refs.dataForm) {
        this.$refs['dataForm'].resetFields()
        this.initialization()
      }
    })
  },
  mounted() {
    this.initialization()
  },
  methods: {
    initialization() {
      this.loading = true
      this.roleOrgType = JSON.parse(JSON.stringify(this.orgTypeArr))
      if (this.roleOrgType.length === 6) {
        this.roleOrgType.splice(4, 1)
      }
      this.perClassificationMerga = JSON.parse(JSON.stringify(this.perClassification))
      for (let index in this.perClassificationMerga) {
        if (this.perClassificationMerga[index].code + '' === '50') {
          this.perClassificationMerga.splice(index, 1)
        }
      }
      this.visible = true
      this.$refs['dataForm'].resetFields()
      this.dataForm = JSON.parse(JSON.stringify(this.emptyForm))
      this.showOrg = false
      this.showMenu = false
      this.showFlow = false
      // this.$refs.menuListTree.setCheckedKeys([])

      // this.$refs.deptListTree.setCheckedKeys([])
      this.querySearch('')
      Promise.all([
        this.getMenuList(),
        this.getActivityList()
      ]).then(() => {
        if (this.$route.query.roleId !== undefined) {
          this.dataForm.roleId = this.$route.query.roleId
          this.getInfo()
        } else {
          this.loading = false
        }
      })
    },
    // 页面返回
    backPage() {
      this.$router.push({
        name: 'sys-role'
      })
    },
    // 获取菜单列表
    getMenuList() {
      return this.$request.get('/sys/menu/selectMenuList').then((res, total, code, data) => {
        this.menuList = this.treeDataTranslateMenu(data.result, 'menuId', 'parentId')
      }).catch(() => { })
    },
    treeDataTranslateMenu(data, id = 'id', pid = 'pid') {
      var res = []
      var temp = {}
      for (var i = 0; i < data.length; i++) {
        temp[data[i][id]] = data[i]
      }
      for (var k = 0; k < data.length; k++) {
        if (!temp[data[k][pid]] || data[k][id] === data[k][pid]) {
          if (data[k].type === 0) {
            res.push(data[k])
          }
          // res.push(data[k])
          continue
        }
        if (!temp[data[k][pid]]['children']) {
          temp[data[k][pid]]['children'] = []
        }
        // if (data[k].hide !== '0') {
        temp[data[k][pid]]['children'].push(data[k])
        data[k]['_level'] = (temp[data[k][pid]]._level || 0) + 1
        // }
      }
      return res
    },
    // 获取部门列表
    getActivityList() {
      return this.$request.get('/sys/role/selectActivity').then((res, total, code, data) => {
        this.activityList = treeDataTranslate(data.result, 'activityId', 'activityPid')
      }).catch(() => { })
    },
    // 获取信息
    getInfo() {
      this.$request.get(`/sys/role/info/${this.dataForm.roleId}`).then((res, total, code, data) => {
        this.dataForm = {
          ...this.dataForm,
          ...data.result
        }
        if (this.dataForm.orgType === '30') {
          this.authTypeArr = JSON.parse(JSON.stringify(this.perClassification))
        } else {
          this.authTypeArr = JSON.parse(JSON.stringify(this.perClassificationMerga))
        }

        if (this.dataForm.roleType === ROLE_AUTH_MENU) {
          this.roleOrgScopeOption = this.roleOrgScope
          this.roleTypeActivity = false
          this.showMenu = true
          this.$nextTick(function () {
            setTimeout(() => {
              if (this.dataForm.menuIdList.length > 0) {
                this.dataForm.menuIdList.forEach(item => this.$refs.menuListTree.setChecked(item, true))
              }
            }, 500);
          })
        }
        if (this.dataForm.roleType === ROLE_AUTH_FLOW) {
          this.roleOrgScopeOption = this.procedureRoleScope
          this.roleTypeActivity = true
          this.showFlow = true
          console.log(this.dataForm.activityIdList[0])
          this.$nextTick(function () {
            if (this.dataForm.activityIdList.length > 0) {
              this.radio = this.dataForm.activityIdList[0]
            }
          })
        }
        if (this.dataForm.roleOrgScope === ROLE_ORG_SCOPE) {
          this.showOrg = true
          this.results = data.result.orgList.map(item => {
            item['value'] = item.orgId
            item['name'] = item['name' + key]
            return item
          })
          let orgIdList = []
          data.result.orgList.forEach(item => {
            orgIdList.push(item.orgId)
          })
          this.dataForm.orgIdList = orgIdList
        }
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
        // this.$refs.deptListTree.setCheckedKeys(this.dataForm.deptIdList)
        this.loading = false
      }).catch(() => {  this.loading = false })
    },
    // 获取公司信息
    querySearch(queryString) {
      // if (queryString !== '') {
      this.$request.get('/sys/org/selectOrg', { name: queryString }).then((res, total, code, data) => {
        this.results = res
        this.results = this.results.map(item => {
          item['value'] = item.name
          return item
        })
      }).catch(() => { })
      // }
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      console.log(this.radio)
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.menuIdList = []
        this.dataForm.activityIdList = []
        if (this.dataForm.roleType === ROLE_AUTH_MENU) {
          this.dataForm.menuIdList = [
            ...this.$refs.menuListTree.getHalfCheckedKeys(),
            ...this.$refs.menuListTree.getCheckedKeys()
          ]
        }
        if (this.dataForm.roleType === ROLE_AUTH_FLOW) {
          this.dataForm.activityIdList.push(this.radio)
        }
        this.saveBtnDisabled = true
        this.$request.post(`/sys/role/${!this.dataForm.roleId ? 'save' : 'update'}`, this.dataForm).then((res, total, code, data) => {
          this.saveBtnDisabled = false
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.tabRemove(this.$store.state.contentTabsActiveName)
            }
          })
        }).catch(() => { this.saveBtnDisabled = false })
      })
    }, 5000, { 'leading': true, 'trailing': false }),
    /**
     * 改变角色范围方法
     */
    changeScope() {
      // 如果是40:指定范围维护数据
      if (this.dataForm.roleOrgScope === ROLE_ORG_SCOPE) {
        this.showOrg = true
      } else {
        this.dataForm.orgIdList = []
        this.showOrg = false
      }
    },
    /**
     * 改变权限分类
     */
    // authType 10:Admin 20：普通用户 30：老师 40：管理层
    orgTypeChange() {
      this.dataForm.authType = ''
      if (this.dataForm.orgType === '30') {
        this.authTypeArr = JSON.parse(JSON.stringify(this.perClassification))
      } else {
        this.authTypeArr = JSON.parse(JSON.stringify(this.perClassificationMerga))
      }
    },
    changeAuthType: function (val) {
    },
    /**
     * 改变角色分类
     */
    changeRoleAuthType() {
      this.dataForm.roleOrgScope = ''
      // 选择菜单
      if (this.dataForm.roleType === ROLE_AUTH_MENU) {
        this.roleOrgScopeOption = this.roleOrgScope
        this.roleTypeActivity = false
        this.showMenu = true
        this.showFlow = false
        // 选择流程
      } else if (this.dataForm.roleType === ROLE_AUTH_FLOW) {
        this.roleOrgScopeOption = this.procedureRoleScope
        this.roleTypeActivity = true
        this.showMenu = false
        this.showFlow = true
        this.showOrg = false
      }
      this.$nextTick(function () {
        this.$refs['dataForm'].clearValidate('roleOrgScope')
      })
    },
    // 删除窗口
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        // this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
        this.$router.push({
          name: 'sys-role'
        })
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.row-mar-l {
  margin-left: 22px;
  margin-bottom: 10px;
}
.location-layout {
  margin-bottom: 20px;
}
.company-distributor.el-form-item {
  width: 93.33% !important;
}

.el-tree {
  width: 300px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: left;
  font-size: 14px;
  padding-right: 8px;
  overflow: hidden;
}
.el-tree-node__content > .el-tree-node__expand-icon {
  z-index: 9;
}
</style>
